import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FolderIcon from '@material-ui/icons/Folder';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, MascaraCNPJ } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import { DataGrid } from "@material-ui/data-grid";
import { Chart } from "react-google-charts";

// import { CircularProgressbar } from 'react-circular-progressbar';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  TextoDescPesquisa,
  DivBtsNoticiaNovidades,
  BtNoticiaNovidades,
  BtNoticiaNovidadesSelecionado,
  ListaFiltroMes,
  BtFiltroMesAtivo,
  BtFiltroMes,
  QntPesquisasTipo,
  DivQtdPesquisaTotal,
  DivQntPesquisasTipo,
  QntPesquisasDiarias,
  DivTabelaRelatorio,
  QntClientesRespondidos,
  ViewGraficoRespondidos,
  GraficoRespondido,
  NomeCategoriaMaterial,
  DivAcordeon,
  DataExtrato,
  ListaExtrato,
  ItemListaExtrato,
  TituloRelatorioTrade
} from './Estilos'

function Relatorios(props) {

  const history = useHistory();
  const [Loading, setLoading] = useState(true);
  const [NomeEvento, setNomeEvento] = useState("Minha Bunge Vendas");
  const [Token, setToken] = useState(localStorage.getItem("c_token"));
  const [IdUser, setIdUser] = useState(localStorage.getItem("id_tb_user"));
  const [TipoUser, setTipoUser] = useState(localStorage.getItem("c_tipo"));
  const [Cargo, setCargo] = useState(localStorage.getItem("c_cargo"));
  const [ListExtrato, setListExtrato] = useState([]);
  const [MesSelecionado, setMesSelecionado] = useState();
  const [MesSelecionadoAgora, setMesSelecionadoAgora] = useState("");
  const [AnoSelecionadoAgora, setAnoSelecionadoAgora] = useState("");
  const [QtdPesquisaTotal, setQtdPesquisaTotal] = useState(0);
  const [QtdGranularTotal, setQtdGranularTotal] = useState(0);
  const [QtdIndiretoTotal, setQtdIndiretoTotal] = useState(0);
  const [GraficoQtdGranularClassico, setGraficoQtdGranularClassico] = useState(0);
  const [GraficoQtdIndireto, setGraficoQtdIndireto] = useState(0);
  const [PesquisaExtratoDetalhes, setPesquisaExtratoDetalhes] = useState([]);
  const [ListPesquisaExtratoDetalhes, setListPesquisaExtratoDetalhes] = useState([]);
  const [MesesAno, setMesesAno] = useState([]);
  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  const [CargosTrade, setCargosTrade]  = useState(['2774', '2820', '2821', '2822', '2773']);
  const [ListExtratoTrade, setListExtratoTrade] = useState([]);


  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Relatórios")
    }
  }, []);

  function MudaPesquisa(Tipo) {
      setTipoSelecionado(Tipo)
      if(Tipo === 0){
        LogAcesso(Token, "Relatório / Pesquisas")
      } else {
        LogAcesso(Token, "Relatório / Extrato")
      }
  }

  useEffect(() => {

    var d = new Date();
    var dia = d.getDate();
    var mes = d.getMonth() + 1;
    var ano = d.getFullYear();
    var ano2 = d.getFullYear().toString().substr(-2);

    var startDate = "6-21";

    var month = parseInt(startDate.split("-")[0]);
    var year = parseInt(startDate.split("-")[1]);
    
    while(!(year === Number(ano2) && month === mes)){

      if(month<12){
        month++;
      } else {
         month = 1;
         year++;
      }

      var MesAno;
      if(month == 1)  { MesAno = 'JAN'; }
      if(month == 2)  { MesAno = 'FEV'; }
      if(month == 3)  { MesAno = 'MAR'; }
      if(month == 4)  { MesAno = 'ABR'; }
      if(month == 5)  { MesAno = 'MAI'; }
      if(month == 6)  { MesAno = 'JUN'; }
      if(month == 7)  { MesAno = 'JUL'; }
      if(month == 8)  { MesAno = 'AGO'; }
      if(month == 9)  { MesAno = 'SET'; }
      if(month == 10) { MesAno = 'OUT'; }
      if(month == 11) { MesAno = 'NOV'; }
      if(month == 12) { MesAno = 'DEZ'; }

      MesesAno.push({
        id: month+'20'+year,
        Mes: MesAno,
        Ano: '20'+year
      });

    }
    
    console.log(MesesAno);

    if(CargosTrade.includes(Cargo)){
      BuscaDadosExtratoTrade(mes, ano);
    } else {
      BuscaDadosExtrato(mes, ano);
    }


  },[]);

  useEffect(() => {
    setMesSelecionado(MesesAno[MesesAno.length-1].id)
  },[MesesAno]);

  function MostraMesLista () {      
    if(MesSelecionadoAgora == 1)  { return 'Janeiro'; }
    if(MesSelecionadoAgora == 2)  { return 'Fevereiro'; }
    if(MesSelecionadoAgora == 3)  { return 'Março'; }
    if(MesSelecionadoAgora == 4)  { return 'Abril'; }
    if(MesSelecionadoAgora == 5)  { return 'Maio'; }
    if(MesSelecionadoAgora == 6)  { return 'Junho'; }
    if(MesSelecionadoAgora == 7)  { return 'Julho'; }
    if(MesSelecionadoAgora == 8)  { return 'Agosto'; }
    if(MesSelecionadoAgora == 9)  { return 'Setembro'; }
    if(MesSelecionadoAgora == 10) { return 'Outubro'; }
    if(MesSelecionadoAgora == 11) { return 'Novembro'; }
    if(MesSelecionadoAgora == 12) { return 'Dezembro'; }
  }

  function BuscaDadosExtrato(MesAno, Ano) {
    console.log('passou', MesAno, Ano );

    setMesSelecionadoAgora(MesAno);
    setAnoSelecionadoAgora(Ano);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "mes": MesAno,
      "ano": Ano
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Extrato/ExtratoPontosAppBunge`, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result);
        if(result.sucesso == true){
          setLoading(false)
          setListExtrato(result.extratoPontos);
        }
        // console.log(result.extratoPontos);
      })
      .catch(error => console.log('error', error));
    
  }

  const BtMes = ( item ) => (
      MesSelecionado == item.id ?
        <BtFiltroMesAtivo>{item.Mes}<span>{item.Ano}</span></BtFiltroMesAtivo>
      :
        <BtFiltroMes onClick={()=>SelecionaMes(item.Mes, item.Ano, item.id)}>{item.Mes}<span>{item.Ano}</span></BtFiltroMes>
  );

  function SelecionaMes(Mes, Ano, Id) {
    setLoading(true);

    setListExtratoTrade([]);    
    setListExtrato([]);
    
    setMesSelecionado(Id);

    var MesAno = 0;
    if(Mes == 'JAN') { MesAno = 1; }
    if(Mes == 'FEV') { MesAno = 2; }
    if(Mes == 'MAR') { MesAno = 3; }
    if(Mes == 'ABR') { MesAno = 4; }
    if(Mes == 'MAI') { MesAno = 5; }
    if(Mes == 'JUN') { MesAno = 6; }
    if(Mes == 'JUL') { MesAno = 7; }
    if(Mes == 'AGO') { MesAno = 8; }
    if(Mes == 'SET') { MesAno = 9; }
    if(Mes == 'OUT') { MesAno = 10; }
    if(Mes == 'NOV') { MesAno = 11; }
    if(Mes == 'DEZ') { MesAno = 12; }

    // console.log(MesAno + ' - ' + Ano);

    if(CargosTrade.includes(Cargo)){
      console.log('passouxxxx');
      BuscaDadosExtratoTrade(MesAno, Ano);
    } else {
      BuscaDadosExtrato(MesAno, Ano);
    }

    PegaDadosPesquisas(MesAno, Ano);

  }

  function PegaDadosPesquisas(mes, ano) {

    // console.log(props.c_token);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");
    
    var raw = JSON.stringify({
      "mes": mes,
      "ano": ano
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    fetch(`${URLBunge}/api/Extrato/PesquisaExtrato`, requestOptions)
      .then(response => response.json())
      .then(result => {
        // console.log('PegaDadosPesquisas', result)
        
        if(result.sucesso == true) {
          setQtdPesquisaTotal(result.qtdPesquisaTotal);
          setQtdGranularTotal(result.qtdGranularTotal);
          setQtdIndiretoTotal(result.qtdIndiretoTotal);
          setGraficoQtdGranularClassico(Number(result.graficoQtdGranularClassico));
          setGraficoQtdIndireto(Number(result.graficoQtdIndireto));
          setPesquisaExtratoDetalhes(result.pesquisaExtratoDetalhes);
          setLoading(false);
        }
        console.log('pesquisaExtratoDetalhes', result.pesquisaExtratoDetalhes)

      })
      .catch(error => console.log('error', error));

  }

  useEffect(() => {
    var d = new Date();
    var mes = d.getMonth() + 1;
    var ano = d.getFullYear();
    PegaDadosPesquisas(mes, ano);
  },[]);

  const columns = [
    {
      field: "tipo",
      headerName: "Tipo",
      width: 100,
    },
    {
      field: "dia",
      headerName: "Dia",
      width: 100,
      headerAlign: 'right',
      type: 'number'
    },
    {
      field: "realizados",
      headerName: "Quantidade",
      width: 130,
      headerAlign: 'right',
      type: 'number',
    }
  ];
  
  function TituloAcordeon(pontos, moedas) {
    return <>
      <div>
        <div>+ <div>{pontos}</div> pontos</div>
        <div>+ <div>{moedas}</div> moedas</div>
      </div>
    </>
  }

  function BuscaDadosExtratoTrade(MesAno, Ano) {

    setMesSelecionadoAgora(MesAno);
    setAnoSelecionadoAgora(Ano);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "mes": MesAno,
      "ano": Ano
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Extrato/PesquisaExtratoTrade`, requestOptions)
      .then(response => response.json())
      .then(result => {
        // setTimeout(() => { setCarregando(false) }, 500);
        console.log('result', result);
        if(result.sucesso == true){
          setListExtratoTrade(result.listaExtrato);
        }
      })
      .catch(error => console.log('error', error));
    
  }

  function TituloAcordeonTrade(razao, cnpj, sap) {
    return <>
    <TituloRelatorioTrade>
      <div>{MascaraCNPJ(cnpj)}</div>
      <div>{razao}</div>
    </TituloRelatorioTrade>
    </>
  }


  return (
    <>  

        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>

            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Relatório de pesquisas</TitNoticias>
                    <TextoDescPesquisa>Análises de pesquisas e extratos de pontos e moedas</TextoDescPesquisa>

                    <Clear />
                    <ListaFiltroMes> { MesesAno.map((item, index) => { return BtMes(item) }) } </ListaFiltroMes>




                    
                    {CargosTrade.includes(Cargo) ?
                    
                      <>
                        <div>

                        { ListExtratoTrade.length > 0 ?
                          <DivAcordeon>
                            { ListExtratoTrade.slice().reverse().map((item, key) => {
                              return <>
                                <Accordion style={{backgroundColor: 'rgba(0,0,0,0.15)', marginBottom: 10, marginLeft: 10, marginRight: 10}}>
                                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={'panel'+key+item.sap+'a-content'} id={'panel'+key+item.sap+'a-header'}> 
                                    <NomeCategoriaMaterial>
                                      <DataExtrato>{TituloAcordeonTrade(item.razao, item.cnpj, item.sap)}</DataExtrato>
                                    </NomeCategoriaMaterial>
                                  </AccordionSummary>
                                  <ListaExtrato>
                                    {
                                      item.pesquisas.map((item, key) => {
                                        return <>
                                        <ItemListaExtrato>
                                          <div>{item.tipo}</div>
                                          <div>{item.realizados}</div>
                                        </ItemListaExtrato>
                                        </>
                                      })
                                    }
                                  </ListaExtrato>
                                </Accordion>
                              </>
                            })
                            }
                          </DivAcordeon>
                        :

                          !Loading ?
                          <div>Não existem dados para este filtro.</div>
                          : null

                        }

                        </div>
                      </>

                    :

                      <>

                        <DivBtsNoticiaNovidades>
                          {TipoSelecionado == 0 ?
                            <BtNoticiaNovidadesSelecionado>PESQUISAS</BtNoticiaNovidadesSelecionado>
                          :
                            <BtNoticiaNovidades onClick={()=>MudaPesquisa(0)}>PESQUISAS</BtNoticiaNovidades>
                          }
                          {TipoSelecionado == 1 ?
                            <BtNoticiaNovidadesSelecionado>EXTRATO</BtNoticiaNovidadesSelecionado>
                          :
                            <BtNoticiaNovidades onClick={()=>MudaPesquisa(1)}>EXTRATO</BtNoticiaNovidades>
                          }
                        </DivBtsNoticiaNovidades>
                        <Clear />

                        {TipoSelecionado == 0 ?
                            <>
                              { TipoUser == 7 ? <DivQtdPesquisaTotal> <div>{QtdPesquisaTotal}</div> pesquisas </DivQtdPesquisaTotal> : null }
                              <DivQntPesquisasTipo>
                                { TipoUser == 2479 || TipoUser == 7 ? <QntPesquisasTipo> <div>{QtdGranularTotal}</div> Granular e Clássico </QntPesquisasTipo> : null }
                                { TipoUser == 2277 || TipoUser == 7 ? <QntPesquisasTipo> <div>{QtdIndiretoTotal}</div> Indireto </QntPesquisasTipo> : null }
                              </DivQntPesquisasTipo>
                              <Clear />

                              <QntPesquisasDiarias>Quantidade de pesquisas diárias</QntPesquisasDiarias>

                              <DivTabelaRelatorio>
                                <DataGrid
                                  rows={PesquisaExtratoDetalhes}
                                  columns={columns}
                                  pageSize={30}
                                  // checkboxSelection
                                  disableSelectionOnClick
                                  hideFooter={true}
                                  autoHeight={true}
                                  // id="dia"
                                  // getRowId={'dia'}
                                  getRowId={(r) => r.dia+r.tipo}
                                  disableColumnFilter={true}
                                  disableColumnMenu={true}
                                />
                              </DivTabelaRelatorio>
                              <Clear />

                              <QntClientesRespondidos>
                                % de clientes respondidos
                                <div>De acordo com a sua carteira de clientes</div>
                              </QntClientesRespondidos>
                              <Clear />


                              <ViewGraficoRespondidos>

                                { TipoUser == 2479 || TipoUser == 7 ?
                                <GraficoRespondido>
                                  <CircularProgressbar
                                    value={GraficoQtdGranularClassico}
                                    text={`${GraficoQtdGranularClassico}%`}
                                    strokeWidth={15}
                                    styles={buildStyles({
                                      textColor: '#000000',
                                      trailColor: '#d4dfec',
                                      pathColor: '#7b99c5',
                                      backgroundColor: '#000000',
                                    })}
                                  />
                                  <div className={'TipoGrafico'}>Granular e Clássico</div>
                                </GraficoRespondido>
                                : null
                                }

                                { TipoUser == 2277 || TipoUser == 7 ?
                                <GraficoRespondido>
                                  <CircularProgressbar
                                    value={GraficoQtdIndireto}
                                    text={`${GraficoQtdIndireto}%`}
                                    strokeWidth={15}
                                    styles={buildStyles({
                                      textColor: '#000000',
                                      trailColor: '#d4dfec',
                                      pathColor: '#7b99c5',
                                      backgroundColor: '#000000',
                                    })}
                                  />
                                  <div className={'TipoGrafico'}>Indireto</div>                              
                                </GraficoRespondido>
                                : null
                                }

                              </ViewGraficoRespondidos>

                              </>
                        :
                            <>
                        
                        
                        
                        { ListExtrato.length > 0 ?
                          <>
                          
                          
                          <DivAcordeon>
                                { ListExtrato.slice().reverse().map((item, key) => {
                                    return <>    
                                      <Accordion style={{backgroundColor: 'rgba(0,0,0,0.11)', marginBottom: 10, marginLeft: 10, marginRight: 10}}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={'panel'+item.id+'a-content'} id={'panel'+item.id+'a-header'}> 
                                          <NomeCategoriaMaterial>

                                            <DataExtrato>{item.dia} de {MostraMesLista()}</DataExtrato>
                                            {/* { TituloAcordeon(item.pontos, item.moedas) } */}

                                          </NomeCategoriaMaterial>
                                        </AccordionSummary>

                                          <ListaExtrato>
                                            
                                            {
                                              item.pontosDetalhes.map((item, key) => {
                                                return <>
                                                <ItemListaExtrato>
                                                  <div>{item.cad_descricao}</div>
                                                  <div>

                                                    {item.cad_cod == 678 ? <>-</> : null }
                                                    {item.cad_cod == 5513 ? <>-</> : null }
                                                    {item.cad_cod == 86250 ? <>+</> : null }
                                                    {item.cad_cod == 86251 ? <>+</> : null }
                                                    {item.cad_cod == 86252 ? <>+</> : null }
                                                    {item.cad_cod == 86253 ? <>+</> : null }
                                                    {item.cad_cod == 86254 ? <>+</> : null }
                                                    {item.cad_cod == 86255 ? <>+</> : null }

                                                    {item.valor} {item.tipo}
                                                  </div>
                                                </ItemListaExtrato>
                                                </>
                                              })
                                            }

                                          </ListaExtrato>

                                        </Accordion>

                                    </>
                                  })
                                  }
                          </DivAcordeon>
                          
                          
                          </>
                        :
                          <>

                            <div>Não existem dados para este filtro.</div>

                          </>
                        }
                        
                        
                        </>
                        }

                      </>
                    }

                </div>
            </ColunaRegras>
            
            <MenuPrinc Pagina="Relatorios" />
         </BackgroundImg>
    </>
  );

}

export default Relatorios;
